import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { Layout } from './App';
import { createAppRouter } from './routes';
import './styles.css';

const host = document.getElementById('root');
if (host === null) throw new Error('корневой элемент #root не найден');

const router = createAppRouter(Layout);

createRoot(host).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
